let PackagesItem = [
    {
        id: 1,
        trackTitle: "Senior Track 🔥",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "$49",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Full Access to Q&A sessions',
        trackLink: 'https://geekle.us/ticket/1657022120264x601559066335510500',
    },
    {
        id: 2,
        trackTitle: "Junior Track",
        trackSubtitle: "For Junior specialists",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Junior Track',
        trackLink: 'https://geekle.us/ticketfree/1657023204449x255259967455756300',
    },
  ];
  
  export default PackagesItem;
  